import { CopyOutlined } from '@ant-design/icons';
import { Toast } from '@capra/core';
import { Tooltip } from 'antd';

import type { MouseEvent } from 'react';

interface CopyToClipboardProps {
  textToCopy: string;
}

export const CopyToClipboard = ({ textToCopy }: CopyToClipboardProps) => {
  const handleCopy = async (event: MouseEvent<HTMLSpanElement>) => {
    try {
      event.stopPropagation();
      await navigator.clipboard.writeText(textToCopy);
      Toast.success('Copied to clipboard', { position: 'bottom-right' });
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : '';
      Toast.error(`Failed to copy text${errorMessage && `: ${errorMessage}`}`, { position: 'bottom-right' });
    }
  };

  return (
    <Tooltip title='Copy to clipboard'>
      <CopyOutlined
        onClick={handleCopy}
      />
    </Tooltip>
  );
};
